import { useState } from 'react';
import { Delivery, DateRangeParams } from '../types';
import { getDeliveriesByDateRange } from '../services';

export const useDeliveries = () => {
  const [deliveries, setDeliveries] = useState<Delivery[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDeliveriesByDateRange = async (params: DateRangeParams) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getDeliveriesByDateRange(params);
      setDeliveries(data);
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Error desconocido al obtener entregas';
      setError(errorMessage);
      console.error('Error en useDeliveries:', errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    deliveries,
    loading,
    error,
    fetchDeliveriesByDateRange
  };
}; 